



















import { Component, Mixins, Prop } from 'vue-property-decorator';
import BaseMixin from '@/mixins/BaseMixin';

@Component
export default class VinSearchResultItem extends Mixins(BaseMixin) {
    @Prop()
    private readonly url!: string | null;

    @Prop()
    private readonly name!: string;

    @Prop()
    private readonly imageUrl!: string | null;
}
